/*
hasil result search after user enter
*/
//@flow
import KickImage from 'Reuseables/KickImage';
import _ from "lodash";
import moment from "moment";
import React from "react";
import Countdown from "react-countdown";
import { Helmet } from "react-helmet";
import InfiniteScroll from 'react-infinite-scroll-component';
import { connect } from "react-redux";
import { hideLoading } from "react-redux-loading-bar";
import { withRouter } from "react-router-dom";
import { Button, Col, Container, Row } from "reactstrap";
import styled from 'styled-components';
import Sneaker from "../Sneakers/Sneaker";

import NotFoundImg from "../../images/dashboard-empty-state.png";
import withScrollTo from "../hoc/withScrollTo";

import {
  doFetchCurrencyRate,
  doFetchProfile
} from "../../actions/authAction";
import {
  getPreVerifiedCollectionList
} from "../../actions/kafairAction";

import {
  doBrowseAll,
  doFetchBrandsPageBanner,
  doFetchBrandsProduct,
  doFetchPopularSearch,
  doFetchProducts,
  doFilteringSearchToApi,
  fetchCollectionProduct,
  getAdditionalPage,
  getCollectionBySlug,
  getCollectionProduct,
  getDetailSection,
  getRecommendedProduct,
  getTopSellingProduct,
  recordCollectionActivity,
  resetCollectionStateData,
  saveCollectionSort,
  saveSearchQueries,
  searchProduct,
  searchState,
  searchToLoadMore,
  sortingSearchResultAPI,
  updateActiveId
} from "../../actions/productAction";
import { CURRENCY_CODE } from '../../constants';
import Analytics from '../../services/Analytics';
import { categorySearch, convertBrandNameToSlug, convertToPreVerified, convertToRupiah, getCloudImageUrl, isExpressShippingFiltered, isFromAppBrowser } from "../../utils/Helpers";
import CardLoading from "../Loading/CardLoading";
import SneakerLoadingSpinner from "../Sneakers/SneakerLoadingSpinner";

//filter and sort
import { getSystemCategory } from "Pages/Home/Helper/Formatter";
import { Banner } from '../../Container/Assets';
import { getAllBrands, getAllSizes } from '../../actions/filterAction';
import { doSetFilterSearch, doSetSortBySearch } from "../../actions/uiAction";
import { ASSET_IMAGE } from '../../config';
import { getQueryParamsUrl } from "../../helpers/url";
import IconFilter from '../../images/filter_icon.png';
import ModalFilterAndSort from '../Modals/ModalFilterAndSort';
import FilterDrawer from './FilterDrawer';
import FilterDropdown from './FilterDropdown';
import SelectedFilter from './SelectedFilter';

const PER_PAGE_DEFAULT = 52;

const BROWSE_ALL_KEYWORD = "BROWSE+ALL";

const isBrowseAll = keyword => {
  if (keyword === undefined) return true;
  return keyword.trim().toUpperCase() === BROWSE_ALL_KEYWORD;
};

export const CardNotFound = ({ title = "Oh snap, we can't find it!", text = "The items you're looking for doesn't seem to exists in our category. Please try in another keywords." }) => (
  <Container className="page-container" style={{ display: "flex", margin: "0 auto" }}>
    <div style={{ flex: 1 }}>
      <div className="not-found" style={{ margin: "0 auto" }}>
        <div className="text-wrapper">
          <p>{title}</p>
          <p>{text}</p>
        </div>
        <div className="img-wrapper">
          <KickImage src={NotFoundImg} />
        </div>
        <div className="button-wrapper">
          <Button href="/" className="btn-black flat spacer">
            Back to Home Page
          </Button>
        </div>
      </div>
    </div>
  </Container>
);

const CountDownWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 24px;
  .title{
    font-size: 20px;
    font-family: DMSans-Bold;
    max-width: 70%;
    text-align: center;
  }
  .description{
    font-size: 16px;
    font-family: DMSans-Regular;
    max-width: 70%;
    text-align: center;
  }
`

const TimerContainer = styled.div`
  border-radius: 27px;
  padding: 12px 20px;
  background-color: #f7f7f7;
  p{
    margin-bottom: 0;
    font-size: 14px;
    font-family: DMSans-Regular;
    span{
      font-family: DMSans-Bold;
    }
  }
`

const CountDownRenderer = ({
  formatted: { days, hours, minutes, seconds },
  completed, ...props
}) => {
  if (completed)
    return <p>ends in <span>00</span> : <span>00</span> : <span>00</span> : <span>00</span></p>
  return <p>ends in <span>{days}</span> : <span>{hours}</span> : <span>{minutes}</span> : <span>{seconds}</span></p>
}

const TimerCountDown = ({
  starts_at,
  expiry,
  description = "",
  name = ""
}) => {
  const ended = moment().isAfter(expiry);
  return (
    <CountDownWrapper>
      <p className="title">{name}</p>
      <p className="description">{description}</p>
      {
        (starts_at && expiry) ?
          <TimerContainer>
            <Countdown
              date={moment(expiry)}
              renderer={CountDownRenderer}
            />
          </TimerContainer>
          : null
      }
    </CountDownWrapper>
  )
}

const arrSortUI = [
  { label: 'FEATURED', value: 'featured' },
  { label: 'MOST_POPULAR', value: 'most_popular' },
  { label: 'BEST_MATCH', value: '' },
  { label: 'MIN_MAX', value: 'price_asc' },
  { label: 'MAX_MIN', value: 'price_desc' },
  { label: 'NEWLY_ADDED', value: 'product_desc' },
  { label: 'SIZE_AVAILABILITY', value: 'available_size' },
]

class BrandPage extends React.Component {
  constructor(props) {
    super(props);

    const isPreVerified = this.props.location.search.includes(
      "express_shipping=true"
    )
      ? true
      : false;
    const isCollectionPage = this.props.location && this.props.location.pathname && this.props.location.pathname.includes('/collection')
    const isHotProductsPage = this.props.location && this.props.location.pathname && this.props.location.pathname.includes('/hot-products')
    const isMostPopularPage = this.props.location && this.props.location.pathname && this.props.location.pathname.includes('/most-popular')
    const isBestSellingPage = this.props.location && this.props.location.pathname && this.props.location.pathname.includes('/best-selling') && this.props.location.pathname !== '/best-selling'
    const isForYou = this.props.location && this.props.location.pathname && this.props.location.pathname.includes('/for-you')
    const isNewlyAdded = this.props.location && this.props.location.search && this.props.location.search.includes('sort_by=product_desc')
    const isTrending = this.props.location && this.props.location.pathname && this.props.location.pathname === '/trending'
    const isBestSellingAllCategory = this.props.location && this.props.location.pathname && this.props.location.pathname === '/best-selling'
    const isHotProductsAllCategory = this.props.location && this.props.location.pathname && this.props.location.pathname === '/hot-products'
    const isPriceDrop = this.props.location && this.props.location.pathname && this.props.location.pathname === '/price-drop'
    const selectedCategory =
      categorySearch(this.props.match.params.category) ?
        categorySearch(this.props.match.params.category) :
        isTrending || isBestSellingAllCategory || isHotProductsAllCategory || isPriceDrop ?
          'all_category' :
          '';

    const getSlugFromParams = () => {
      try {
        return _.last(_.split(this.props.location.pathname, "/"))
      } catch (error) {
        console.log(error)
        return ""
      }
    }

    const brandPageSlug = getSlugFromParams();
    const mustHaveParams = {
      brands: brandPageSlug,
      per_page: PER_PAGE_DEFAULT,
      page: 1,
      availables: true,
    }
    this.state = {
      firstRender: false,
      isLoading: true,
      page: 1,
      isVisible: false,
      keyword_search: "",
      openSearch: false,
      hasMore: true,
      prevY: null,
      isSearchOpen: false,
      isPreVerified,
      searchCategory: selectedCategory,
      isFilterCollapse: false,

      leftOpen: false,
      rightOpen: true,

      //filter and sort
      sortOpen: false,
      filterOpen: false,
      modal: false,
      currentSort: (isCollectionPage || isTrending || isBestSellingAllCategory || isHotProductsAllCategory || isPriceDrop) ? 'NEWLY_ADDED' : 'MOST_POPULAR',
      isBrandExpanded: false,
      isChildBrandExpanded: false,
      isSizeExpanded: false,
      isConditionExpanded: false,
      isPriceExpanded: false,
      activeSize: 'maleSizes',
      activeApparelsSize: 'topSizes',
      selectedBrands: [],
      selectedSizes: {
        maleSizes: [],
        femaleSizes: [],
        kidSizes: [],
        apparelSizes: [],
      },
      sneakers_condition: '',
      startPrice: '',
      endPrice: '',
      alreadySorted: false,
      sex: '',
      typeFilter: "SEARCH_PRODUCT",
      color: '',
      sort_by: "product_desc",
      failedFetchCollectionData: false,

      //collection page
      isCollectionPage: isCollectionPage,
      isFetchingCollection: true,
      pageCollection: 1,
      collectionPrevY: 0,
      loadingCollection: true,
      hasMoreCollection: true,
      sizeParams: {
        sizeId: "",
        size_types: "",
        sizes: "",
        sizeAlias: "",
      },

      //hot products
      isHotProductsPage: true,
      pageHotProducts: 1,
      prevYHotProducts: 0,
      loadingHotProducts: true,
      hasMoreHotProducts: true,

      //most popular
      pageMostPopular: 1,
      prevYMostPopular: 0,
      loadingMostPopular: true,
      hasMoreMostPopular: true,
      isMostPopularPage: isMostPopularPage,
      isBestSellingPage: isBestSellingPage,

      //drawer
      isDrawerOpen: false,

      //for you
      isForYou: isForYou,
      isForYouLoading: true,
      isForYouPage: 1,
      isForYouHasMore: true,
      prevYForYou: 0,
      collection_id: null,

      //newly added
      isNewlyAdded: isNewlyAdded,

      // New homepage
      isTrendingPage: isTrending,
      isBestSellingAllCategoryPage: isBestSellingAllCategory,
      isHotProductsAllCategoryPage: isHotProductsAllCategory,
      isPriceDropPage: isPriceDrop,

      brandPageParams: { ...mustHaveParams },
      brandPageSlug,
      brandPageBanner: "",
      hasMoreBrandProduct: true,
      loadingBrandProduct: true,

      // meta tag implementation
      metaTitle: "",
      metaDescription: "",
    };
    this.handleLoadMore = this.handleLoadMore.bind(this);
    this._scrollToTop = this._scrollToTop.bind(this);
    this._handleScrolling = this._handleScrolling.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleMappingSearchResult = this.handleMappingSearchResult.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.openSearch = this.openSearch.bind(this);
    this.handleClear = this.handleClear.bind(this);

    //filter and sort
    this.toggleModalSearch = this.toggleModalSearch.bind(this);
    this._handleSorting = this._handleSorting.bind(this);
  }

  componentDidMount() {
    (async () => {
      const { searchCategory, sort_by } = this.state;
      document.addEventListener("scroll", this._handleScrolling);
      const { dataProduct, dataCategory, dataAuth, getPreVerifiedCollectionList } = this.props;
      const { searchKeyword, stillPending, isSearchResultPending, caseSorting } = dataProduct;

      this.props.doFetchBrandsProduct(this.objectToParamsString(Object.assign(this.state.brandPageParams, { sort_by })))
      this.handleFetchBanner(this.state.searchCategory, this.state.brandPageSlug)

      await this.handleDetectSortedBy(true);

      this.props.resetCollectionData();

      if (dataAuth.isLogged) {
        this.props.fetchProfile().then((res) => {
          try {
            let code = res.value.data.country_code
            const currencyCode = CURRENCY_CODE[code === 'IDN' ? 'IDN' : 'ETC'];
            this.props.fetchCurrencyRate(currencyCode);
          } catch (err) {
            this.props.fetchCurrencyRate(CURRENCY_CODE['IDN']);
          }
        });
      }

      const params = this.getQueryParamsUrl();
      let keyword = params && params.keyword ? params.keyword : "";

      let searchKeywordFilter = keyword === undefined ? "BROWSE ALL"
        : keyword
          .toUpperCase()
          .replace(/\+/g, " ")
          .trim();
      const { search } = this.props.location;
      const _isBrowseAll = isBrowseAll(keyword);
      keyword = keyword
        ? keyword
          .toUpperCase()
          .replace(/\+/g, " ")
          .trim()
        : "";
      this.setState({
        openSearch: true,
        keyword_search: _isBrowseAll ? "" : keyword,
        searchCategory: ""
      });

      const _queries = getQueryParamsUrl(this.props.history.location.search);
      const queries = convertToPreVerified(_queries)

      const selectedCategory = categorySearch(this.props.match.params.category);
      const arrSizeId = queries?.sizeId?.split(',')
      const arrSizeTypes = queries?.sizeTypes?.split(',')
      const arrSizeUs = queries?.sizes?.split(',')
      const arrSizeAlias = queries?.sizeAlias?.split(',')

      this.setState({
        color: queries.colours ? queries.colours : "",
        brands: queries.brands ? queries.brands : "",
        sneakers_condition: queries.sneakersCondition ? queries.sneakersCondition : "",
        startPrice: queries.startPrice ? queries.startPrice : "",
        endPrice: queries.endPrice ? queries.endPrice : "",
        sex: queries.sex ? queries.sex : "",
        keyword_search: queries.keyword ? queries.keyword : "",
        searchCategory: selectedCategory ? selectedCategory : "",
        sizeParams: {
          sizeId: arrSizeId,
          size_types: arrSizeTypes,
          sizes: arrSizeUs,
          sizeAlias: arrSizeAlias,
        },
      });

      const query = { params: { category: searchCategory } }
      this.setState({
        filterOpen: false,
        selectedBrands: queries?.brands?.split(',') || [],
        selectedSizes: {
          maleSizes: [],
          femaleSizes: [],
          kidSizes: [],
          apparelSizes: [],
        }
      }, () => {
        this.props.getAllBrands(query);
        this.props.getAllSizes(query);
      });

      //collection page
      const { computedMatch: { params: { category, slug } } } = this.props;

      this.props.getDetailSection(searchCategory, "editors-pick")
      // const params = {
      //   page: this.state.pageHotProducts,
      //   availables: true,
      //   category: searchCategory,
      //   sort_by: this.state.sort_by
      // }
      const collectionSortedBy = JSON.parse(localStorage.getItem('collectionSortedBy'));
      if (collectionSortedBy && collectionSortedBy?.sort_by) {
        params.sort_by = collectionSortedBy?.sort_by
      }
      this.props.getAdditionalPage('editors-choices', { params });

      let optionsHotProducts = {
        root: null,
        rootMargin: '0px',
        threshold: 1.0
      };
      const isInfiniteScrolLHotProducts = !isFromAppBrowser();
      this.setState({ isInfiniteScrolLHotProducts })
      // if (isInfiniteScrolLHotProducts) {
      //   document.addEventListener("DOMContentLoaded", function () {
      //     // Create an observer instance
      //     this.observer = new IntersectionObserver(
      //       this.handleObserverHotProducts.bind(this), // pass the callback
      //       optionsHotProducts
      //     );
      //     console.log(this.observer.observe, "DEBUG this.observer.observe")
      //     this.observer.observe(this.loadingRef);
      //   });

      // }


      if (window.innerWidth >= 525) {
        this.props.setFilter(true);
      }
    })()
  }

  async componentDidUpdate(prevProps) {
    const { isPreVerified, firstRender, isNewlyAdded } = this.state;
    const { selected } = this.props.dataCategory;
    const { dataAuth } = this.props
    const { params } = this.props.match;
    const categoryParams = (typeof params.category !== 'undefined' && params.category) ? params.category : "";
    let searchCategory = categoryParams;

    if (prevProps.dataAuth.userdata.id !== this.props.dataAuth.userdata.id) {
      this.props.getRecommendedProduct(this.props.dataAuth.userdata.id);
    }

    const arr = [
      { label: 'FEATURED', value: 'featured' },
      { label: 'MOST_POPULAR', value: 'most_popular' },
      { label: 'BEST_MATCH', value: '' },
      { label: 'MIN_MAX', value: 'price_asc' },
      { label: 'MAX_MIN', value: 'price_desc' },
      { label: 'NEWLY_ADDED', value: 'product_desc' },
    ]


    //HIT FILTER/SEARCH API WHEN URL IS CHANGED
    if (
      (
        (prevProps.match.url !== this.props.match.url && this.props.match.url) ||
        prevProps.location.search !== this.props.location.search
      )
    ) {
      const params = this.getQueryParamsUrl();
      let keyword = params && params.keyword ? params.keyword : "";
      let searchKeywordFilter = keyword === undefined ? "BROWSE ALL"
        : keyword
          .toUpperCase()
          .replace(/\+/g, " ")
          .trim();
      const { search } = this.props.location;
      const _isBrowseAll = isBrowseAll(keyword);

      const _queries = getQueryParamsUrl(this.props.history.location.search);
      const queries = convertToPreVerified(_queries);

      const selectedCategory = categorySearch(this.props.match.params.category);

      this.setState({
        color: queries.colours ? queries.colours : "",
        sneakers_condition: queries.sneakersCondition ? queries.sneakersCondition : "",
        startPrice: queries.startPrice ? queries.startPrice : "",
        endPrice: queries.endPrice ? queries.endPrice : "",
        sex: queries.sex ? queries.sex : "",
        searchCategory: selectedCategory ? selectedCategory : "",
        brandPageParams: {
          ...this.state.brandPageParams,
          ...convertToPreVerified(params),
          page: 1,
        },
      });

      const payload = {
        ...this.state.brandPageParams,
        sneakers_condition: queries.sneakersCondition ? queries.sneakersCondition : "",
        start_price: queries.startPrice ? queries.startPrice : "",
        end_price: queries.endPrice ? queries.endPrice : "",
        color: queries.colours ? queries.colours : "",
        sex: queries.sex ? queries.sex : "",
        sort_by: queries.sort_by ? queries.sort_by : "",
        page: 1 //reset to fetch page 1 only when new filters are applied
      }

      this.props.doFetchBrandsProduct(this.objectToParamsString(payload));
    }

    if (prevProps.location !== this.props.location) this._scrollToTop();

    if (
      prevProps.dataProduct.isSearchResultPending &&
      prevProps.dataProduct.isSearchResultPending !==
      this.props.dataProduct.isSearchResultPending
    ) {
      const { pagination, isSearchResultPending } = this.props.dataProduct;
      const currentPage = pagination ? pagination.current_page : 1;
      await this.setState({
        hasMore: pagination ? pagination.next_page !== null : false,
        isLoading: isSearchResultPending,
        page: currentPage,
        prevY: currentPage === 1 ? null : this.state.prevY
      });
      // const offsetTop = document.getElementById('product').offsetTop;
      const { page } = this.state;
      if (page === 1) {
        this._scrollToTop();
      } else {
        // if(page !== 1){
        // const offsetTop = document.getElementById("product").offsetTop;
        // const height = this.state.productScrollHeight;
        // this._scrollToTop(height + 100);
      }
      this.props.hideLoading();
    }

    //filter and sort
    if (prevProps.dataCategory.selected != selected) {
      const query = { params: { category: selected } }
      this.setState({
        filterOpen: false,
        selectedBrands: [],
        selectedSizes: {
          maleSizes: [],
          femaleSizes: [],
          kidSizes: [],
          apparelSizes: [],
        },
        page: 1,
      }, () => {
        // this.props.getAllBrands(query);
        // this.props.getAllSizes(query);
        this.props.getPopularSearch(query);
      });
    }

    // Handler for UI sort dropdown
    // By default there are only 2 condition for sorting: most popular and best match
    if (prevProps.isSortOpen !== this.props.isSortOpen && this.props.isSortOpen) {
      // if (!this.state.alreadySorted) {
      //   const params = getQueryParamsUrl(this.props.history.location);
      //   const arrParams = params.pathname.split('/');
      //   this.setState({
      //     // currentSort: arrParams[arrParams.length - 1] === 'browse+all' ? 'MOST_POPULAR' : '',
      //     currentSort: "MOST_POPULAR",
      //     alreadySorted: true,
      //   });
      // } else {
      const { isCollectionPage } = this.state;
      const { caseSorting } = this.props.dataProduct;
      // let sort = caseSorting === "" ? '' : caseSorting;

      const productSort = arr.find(item => item.value === caseSorting);
      const sortUpdated = isCollectionPage ? this.state.currentSort : this.state.currentSort ? this.state.currentSort : productSort.label

      this.setState({
        currentSort: sortUpdated
      });
      // }
    }

    if (prevProps.location.search !== this.props.location.search) {
      const params = getQueryParamsUrl(this.props.history.location.search);
      const { category } = this.props.match.params;

      this.setState({
        // color: params.color ? params.color : "",
        brands: params.brands ? params.brands : "",
        selectedBrands: params?.brands?.split(','),
        // sneakers_condition: params.sneakersCondition ? params.sneakersCondition : "",
        // startPrice: params.startPrice ? params.startPrice : "",
        // endPrice: params.endPrice ? params.endPrice : "",
        // sex: params.sex ? params.sex : "",
        // sizesParams: params.sizesParams ? params.sizesParams : "",
        searchCategory: category ? category : "",
        page: 1,
      })
    }

    //hot products
    if (prevProps.dataCategory !== this.props.dataCategory) {
      const { dataCategory } = this.props;
      await this.setState({
        page: 1,
        pageHotProducts: 1,
        loadingHotProducts: true,
        hasMoreHotProducts: true,
        prevYHotProducts: 0
      });
      !this.state.isHotProductsPage && this.props.getAdditionalPage('editors-choices', { params: { page: this.state.page, availables: true, category: dataCategory } });
    }

    if (prevProps.dataProductBrandPage.products.isFetch && !this.props.dataProductBrandPage.products.isFetch) {
      const { next_page } = this.props.dataProductBrandPage.products;
      this.setState({
        hasMoreBrandProduct: next_page ? true : false,
        loadingBrandProduct: false
      })
    }
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this._handleScrolling);
  }

  objectToParamsString(obj = {}) {
    let result = ""

    for (let k in obj) {
      if (!obj[k]) {
        continue;
      }


      if (!result) {
        result += `?${k}=${obj[k]}`
      } else {
        result += `&${k}=${obj[k]}`
      }
    }


    return result + `&category=${getSystemCategory(this.props.location.pathname.split('/')[1])}`;
  }

  _isOnTop = buffer => window.pageYOffset + buffer <= buffer;

  handleDetectSortedBy(isOnDidMount = false) {
    const queries = getQueryParamsUrl(this.props.history.location.search);
    const { isHotProductsPage, isCollectionPage, isPreVerified, isTrendingPage, isBestSellingAllCategoryPage, isHotProductsAllCategoryPage, isPriceDropPage } = this.state;
    const collectionSortedBy = JSON.parse(localStorage.getItem('collectionSortedBy'));

    if (queries.sortBy) {
      this.setState({
        sort_by: queries.sortBy,
        currentSort: this.convertSort(queries.sortBy)
      }, () => {
        return this.state;
      });
    } else if (collectionSortedBy) {
      if (isOnDidMount) return;
      this.setState({
        sort_by: collectionSortedBy.sort_by,
        currentSort: collectionSortedBy.currentSort
      }, () => {
        return this.state;
      });
    } else if (isHotProductsPage) {
      this.setState({
        currentSort: "NEWLY_ADDED"
      }, () => {
        return this.state;
      })
    } else {
      this.setState({
        currentSort: (isCollectionPage && isPreVerified) ?
          "MIN_MAX" :
          (isCollectionPage || isTrendingPage || isBestSellingAllCategoryPage || isHotProductsAllCategoryPage || isPriceDropPage) ?
            'NEWLY_ADDED' :
            "MOST_POPULAR"
      }, () => {
        return this.state;
      })
    }
  }

  getQueryParamsUrl() {
    const checker = new URLSearchParams(this.props.location.search);
    let objParams = {};
    for (let pair of checker.entries()) {
      objParams = {
        ...objParams,
        [pair[0]]: pair[1]
      };
    }
    return objParams;
  }

  dolarToRupiah = (price = 0) => {
    if (!price) {
      return 0
    }
    return Math.round(parseFloat(price) / this.props.dataAuth.userCurrency.ratio)
  }

  handleFetchBanner = async (category, slug) => {
    try {
      const data = await doFetchBrandsPageBanner(category)
      const brands = _.get(data, "data.data")
      const brand = _.find(brands, { slug })

      if (brand?.images?.length) {
        const landscapeImage = brand.images.find((i) => i.orientation === "landscape");
        const portraitImage = brand.images.find((i) => i.orientation === "portrait");

        this.setState({
          brandPageBanner: window.innerWidth <= 760 ? portraitImage : landscapeImage
        })
      }

      if (brand?.meta !== null) {
        this.setState({
          metaTitle: brand.meta.title,
          metaDescription: brand.meta.description,
        });
      } else {
        this.setState({
          metaTitle: brand?.name,
          metaDescription: brand?.description,
        });
      }

      this.setState({
        brandName: brand?.name ?? "",
        brandDescription: brand?.description ?? ""
      })
    } catch (error) {
      console.log(error)
    }
  }

  fetchHotProducts = () => {
    const { searchCategory } = this.state;

    this.props.getDetailSection(searchCategory, "editors-pick")
    this.props.getAdditionalPage('editors-choices', {
      params: {
        page: this.state.pageHotProducts,
        availables: true,
        category: searchCategory
      }
    });

    this.props.history.push({
      pathname: `hot-products`,
    })

    let optionsHotProducts = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0
    };
    const isInfiniteScrolLHotProducts = !isFromAppBrowser();
    this.setState({ isInfiniteScrolLHotProducts })
    if (isInfiniteScrolLHotProducts) {
      // Create an observer instance
      this.observer = new IntersectionObserver(
        this.handleObserverHotProducts.bind(this), // pass the callback
        optionsHotProducts
      );
      this.observer.observe(this.loadingRef);
    }
  }

  fetchMostPopular = (section) => {
    const { searchCategory } = this.state;

    this.props.getDetailSection(searchCategory, section)

    this.props.history.push({
      pathname: section === 'trending-now' ? `most-popular` : `best-selling`
    })

    let optionsMostPopular = {
      root: null,
      rootMargin: '0px',
      threshold: 0.7
    };
    const isInfiniteScrolLMostPopular = !isFromAppBrowser();
    this.setState({ isInfiniteScrolLMostPopular })
    this.getProductListMostPopular();
    if (isInfiniteScrolLMostPopular) {
      // Create an observer instance
      this.observer = new IntersectionObserver(
        this.handleObserverMostPopular.bind(this), // pass the callback
        optionsMostPopular
      );
      this.observer.observe(this.loadingRef);
    }
  }

  _handleNextPageClick = async () => {
    await this.setState({
      productScrollHeight: this.productContainerRef && this.productContainerRef.scrollHeight
    });
    await this.handleLoadMore();
  };

  handlePrice(price) {
    if (price === null) {
      return <p style={{ paddingTop: "5px" }}>Out of Stock</p>;
    } else {
      return (
        <div>
          <p style={{ paddingBottom: "5px", paddingTop: "5px" }}>Harga dari</p>
          <p>IDR. {convertToRupiah(Number(price.asking_price))}</p>
        </div>
      );
    }
  }

  async handleLoadMore() {
    let searchCategory = this.state.searchCategory;

    if (searchCategory) {
      switch (searchCategory) {
        case 'streetwear':
        case 'fashion':
        case 'apparel':
          searchCategory = 'apparels'
          break;
        case 'luxury':
          searchCategory = 'handbags'
          break;
        case 'lifestyle':
        case 'toys':
        case 'electronics-collectibles':
          searchCategory = 'lifestyles'
          break;
        case 'all_category':
        case 'bcaxkickavenue':
          searchCategory = '';
          break;
        default:
          break;
      }
    }

    const {
      searchKeyword,
      isFiltering,
      caseSorting
      // pagination:{ current_page }
    } = this.props.dataProduct;

    const params = this.getQueryParamsUrl();
    const keyword = params && params.keyword ? params.keyword : "";

    let searchKeywordFilter = keyword === undefined ? "BROWSE+ALL"
      : keyword
        .toUpperCase()
        .replace(/\+/g, " ")
        .trim();
    const { search } = this.props.location;
    await this.setState({
      page: this.state.page + 1,
      isLoading: true
    });
    const _isBrowseAll = isBrowseAll(keyword);
    const { page } = this.state;
    const { dataAuth } = this.props
    if (_isBrowseAll) {
      if (search !== "") {
        let queries = this.getQueryParamsUrl();
        if (dataAuth.isLogged && dataAuth.userdata.country_code !== 'IDN' &&
          queries.hasOwnProperty('start_price') ||
          queries.hasOwnProperty('end_price')) {

          queries.start_price = this.dolarToRupiah(queries.start_price)
          queries.end_price = this.dolarToRupiah(queries.end_price)
        }
        if (caseSorting !== "") {
          this.props.sortingSearchResultAPI(
            "",
            {
              params: {
                ...queries,
                category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
                sort_by: caseSorting,
                page,
                availables: true,
                per_page: PER_PAGE_DEFAULT
              }
            },
            "LOAD_MORE"
          );
        } else {
          this.props.doFilteringSearchToApi(
            "",
            {
              params: {
                ...queries,
                category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
                page,
                availables: true,
                per_page: PER_PAGE_DEFAULT,
                sort_by: caseSorting
              }
            },
            "LOAD_MORE"
          );
        }
      } else {
        // console.log("BROWSE ALL WHEN url/search no media queries");
        if (caseSorting !== "") {
          this.props.sortingSearchResultAPI(
            "",
            {
              params: {
                category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
                sort_by: caseSorting,
                page,
                availables: true,
                per_page: PER_PAGE_DEFAULT,
              }
            },
            "LOAD_MORE"
          );
        } else {
          const payload = {
            params: {
              page: page,
              availables: true,
              category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
              per_page: PER_PAGE_DEFAULT,
              sort_by: caseSorting
            }
          };
          this.props.doBrowseAll(payload, "LOAD_MORE");
        }
      }
    } else {
      if (search !== "") {
        const _queries = this.getQueryParamsUrl();
        let queries = convertToPreVerified(_queries);

        if (dataAuth.isLogged && dataAuth.userdata.country_code !== 'IDN' &&
          queries.hasOwnProperty('start_price') ||
          queries.hasOwnProperty('end_price')) {

          queries.start_price = this.dolarToRupiah(queries.start_price)
          queries.end_price = this.dolarToRupiah(queries.end_price)
        }
        if (caseSorting !== "") {
          this.props.sortingSearchResultAPI(
            "",
            {
              params: {
                ...queries,
                category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
                sort_by: caseSorting,
                page,
                keyword: searchKeywordFilter,
                availables: true,
                per_page: PER_PAGE_DEFAULT
              }
            },
            "LOAD_MORE"
          );
        } else {
          this.props.doFilteringSearchToApi(
            "",
            {
              params: {
                ...queries,
                category: searchCategory === "bcaxkickavenue" ? "" : searchCategory,
                page,
                keyword: searchKeywordFilter,
                availables: true,
                per_page: PER_PAGE_DEFAULT,
                sort_by: caseSorting
              }
            },
            "LOAD_MORE"
          );
        }
      } else {
        const params = {
          keyword: searchKeywordFilter,
          sort_by: caseSorting,
          category: searchCategory === "harbolnas" ? "" : searchCategory,
          per_page: PER_PAGE_DEFAULT,
          page
        };
        this.props.searchToLoadMore(params);
      }
    }
  }

  checkingSearchResult() {
    const dataProduct = this.props.dataProductBrandPage.products;

    const { isPreVerified, searchCategory, firstRender } = this.state;

    if (dataProduct.isSearchResultPending && this.state.page === 1) {
      return <CardLoading />;
    } else if (
      dataProduct.searchResult.length > 0 &&
      (dataProduct.errorMessageSearch === "Sneaker ditemukan" ||
        dataProduct.errorMessageSearch === "Tidak Ada pilihan" ||
        dataProduct.errorMessageSearch === "Hasil telah ditemukan" || dataProduct.errorMessageSearch === "Search products successfully.")
    ) {

      return (
        <InfiniteScroll
          dataLength={dataProduct.length} //This is important field to render the next data
          next={this.handleLoadMore}
          hasMore={this.state.hasMore}
          loader={
            <SneakerLoadingSpinner
              isLoading
              isHide={false}
              wrapperRef={loadingRef => this.loadingRef = loadingRef}
            />
          }
          endMessage={
            <p style={{ textAlign: 'center' }}>
              <b>Yay! You have seen it all</b>
            </p>
          }
          scrollThreshold={0.95}
        >
          <Row
            className="result-search"
            style={{
              minHeight: 500,
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "row"
            }}
          >
            {dataProduct?.searchResult?.lenght ? dataProduct.searchResult.map((item, index) => {
              const brandSlug = convertBrandNameToSlug(item.brands?.[0]);
              Object.assign(item, { brandSlug });

              return (
                <Sneaker
                  {...item}
                  key={index}
                  searchCategory={searchCategory}
                  updateActiveId={this.props.updateActiveId}
                  activeId={this.props.activeId}
                  isPreVerified={isPreVerified}
                />
              );
            }) : null}
          </Row>
        </InfiniteScroll>
      );
    } else {
      if (
        !firstRender || dataProduct.isSearchResultPending &&
        dataProduct.errorMessageSearch === ""
      )
        return <CardLoading />;
      else if (
        dataProduct.searchResult.length === 0 || dataProduct.errorMessageSearch === "Sneaker tidak tersedia!" ||
        dataProduct.errorMessageSearch === "Not Found"
      )
        return <CardNotFound />;
    }
  }

  renderFilterDrawer() {
    const { selected } = this.props.dataCategory;
    const { isHotProductsAllCategoryPage, isTrendingPage, isBestSellingAllCategoryPage, isPriceDropPage } = this.state;
    if (window.screen.availWidth < 480) {
      return (
        <FilterDrawer
          history={this.props.history}
          match={this.props.match}
          onClose={this.toggleDrawer}
          updateState={(key, val, unselectable = true) => this.updateState(key, val, unselectable = true)}
          isBrandExpanded={this.state.isBrandExpanded}
          isChildBrandExpanded={this.state.isChildBrandExpanded}
          isSizeExpanded={this.state.isSizeExpanded}
          isConditionExpanded={this.state.isConditionExpanded}
          isPriceExpanded={this.state.isPriceExpanded}
          activeSize={this.state.activeSize}
          activeApparelsSize={this.state.activeApparelsSize}
          selectedBrands={this.state.selectedBrands}
          selectedSizes={this.state.selectedSizes}
          sneakers_condition={this.state.sneakers_condition}
          startPrice={this.state.startPrice}
          endPrice={this.state.endPrice}
          onSaveLastState={this.onSaveLastState}
          dataCategory={this.props.dataCategory}
          isOpen={this.state.isDrawerOpen}
          sex={this.state.sex}
          color={this.state.color}
          // searchCategory={this.state.searchCategory}
          searchCategory={this.props.match.params.category}
          isCollectionPage={this.state.isCollectionPage}
          isHotProductsPage={this.state.isHotProductsPage}
          fetchHotProducts={this.fetchHotProducts}
          fetchMostPopular={this.fetchMostPopular}
          isMostPopularPage={this.state.isMostPopularPage}
          isBestSellingPage={this.state.isBestSellingPage}
          isForYou={this.state.isForYou}
          dataAuth={this.props.dataAuth}
          isMadeIndonesia={selected === "madeindonesia"}
          categoryOnly={isHotProductsAllCategoryPage || isTrendingPage || isBestSellingAllCategoryPage || isPriceDropPage}
          isHotProductsAllCategoryPage={isHotProductsAllCategoryPage}
          isTrendingPage={isTrendingPage}
          isBestSellingAllCategoryPage={isBestSellingAllCategoryPage}
          isPriceDropPage={isPriceDropPage}
          productAggregations={this.props.productAggregations}
          brandPageParams={this.state.brandPageParams}
          objectToParamsString={this.objectToParamsString.bind(this)}
        />
      )
    }
  }

  renderSearchingResult() {
    let isFilterOpen = this.props.isFilterOpen ? 'open' : 'closed';
    const params = getQueryParamsUrl(this.props.history.location.search);
    const filterParams = [
      { key: "color", value: params.colours },
      { key: "sex", value: params.sex },
      // { key: "filterPrice", value: params },
      { key: "startPrice", value: params.startPrice },
      { key: "endPrice", value: params.endPrice },
      { key: "sneakers_condition", value: params.sneakersCondition },
      { key: "sizeId", value: params.sizeId },
      { key: "sizeTypes", value: params.sizeTypes },
      { key: "sizes", value: params.sizes },
      { key: "sizeAlias", value: params?.sizeAlias },
    ].concat(params.brands ? params.brands.split(',').map(t => {
      return { key: "brands", value: t }
    }) : [{ key: "brands", value: undefined }]);
    return (
      <>
        <Row className="filter__sort__product">
          <Col style={{ padding: 0 }} lg="1" md="2" sm="2" xs="6" className="border__btn__bottom btn__filter">
            {
              this.props.isFilterOpen &&
              <div onClick={this.toggleFilter} className="wrapping__btn btn-filter">
                <span><KickImage className="filter__icon" src={IconFilter} alt="" /> Filter <i className="fa fa-angle-left"></i></span>
              </div>
            }
            {
              !this.props.isFilterOpen &&
              <div onClick={this.toggleFilter} className="wrapping__btn btn-filter">
                <span><KickImage className="filter__icon" src={IconFilter} alt="" /> Filter <i className="fa fa-angle-right"></i></span>
              </div>
            }
          </Col>

          <Col style={{ padding: 0 }} lg="9" md="7" sm="7" xs="" className={"selected-sort-filter"}>
            <Row className="scroll-wrapper">
              <SelectedFilter
                searchKeyword={''}
                removeFilter={this.removeFilter}
                selectedCategory={this.props.match.params.category}
                data={filterParams}
                color={this.props.dataFilter.color}
                sex={this.props.dataFilter.sex}
                startPrice={this.props.dataFilter.startPrice}
                endPrice={this.props.dataFilter.endPrice}
                brands={this.props.dataFilter.brands}
                sizes={this.props.dataFilter.sizes}
                sneakers_condition={this.props.dataFilter.sneakers_condition}
                brandList={this.props.brandList}
                resetFilter={this.resetFilter}
                isCollectionPage={this.state.isCollectionPage}
                isHotProductsPage={this.state.isHotProductsPage && !this.state.isHotProductsAllCategoryPage}
                isMostPopularPage={this.state.isMostPopularPage}
                isBestSellingPage={this.state.isBestSellingPage}
              />
            </Row>
          </Col>

          <Col style={{ padding: 0 }} lg="2" md="3" sm="3" xs="6" className={`border__btn__bottom btn__sort`}>
            {
              this.props.isSortOpen &&
              <div className="wrapping__btn btn-sort border__btn__bottom" onClick={this.toggle}>
                <p>Sort: <span>{this.currentSort(this.state.currentSort)} </span></p><i className="fa fa-angle-up"></i>
              </div>
            }
            {
              !this.props.isSortOpen &&
              <div className="wrapping__btn btn-sort border__btn__bottom" onClick={this.toggle}>
                <p>Sort: <span>{this.currentSort(this.state.currentSort)} </span></p><i className="fa fa-angle-down"></i>
              </div>
            }
            {
              this.props.isSortOpen &&
              this.renderSortDropdown()
            }
          </Col>
        </Row>

        <Row className="filter__sort__drawer">
          <Col style={{ padding: 0 }} lg="1" md="2" sm="2" xs="5" className="border__btn__bottom btn__filter">
            {
              this.state.isDrawerOpen &&
              <div onClick={this.toggleDrawer} className="wrapping__btn btn-filter">
                <span><KickImage className="filter__icon" src={IconFilter} alt="" /> Filter <i className="fa fa-angle-left"></i></span>
              </div>
            }
            {
              !this.state.isDrawerOpen &&
              <div onClick={this.toggleDrawer} className="wrapping__btn btn-filter">
                <span><KickImage className="filter__icon" src={IconFilter} alt="" /> Filter <i className="fa fa-angle-right"></i></span>
              </div>
            }
          </Col>

          <Col style={{ padding: 0 }} lg="2" md="3" sm="3" xs="7" className={`border__btn__bottom btn__sort`}>
            {
              this.props.isSortOpen &&
              <div className="wrapping__btn btn-sort border__btn__bottom" onClick={this.toggle}>
                <p>Sort: <span>{this.currentSort(this.state.currentSort)} </span></p><i className="fa fa-angle-up"></i>
              </div>
            }
            {
              !this.props.isSortOpen &&
              <div className="wrapping__btn btn-sort border__btn__bottom" onClick={this.toggle}>
                <p>Sort: <span>{this.currentSort(this.state.currentSort)} </span></p><i className="fa fa-angle-down"></i>
              </div>
            }
            {
              this.props.isSortOpen &&
              this.renderSortDropdown()
            }
          </Col>
        </Row>

        <Row className="filter__sort__drawer">
          <Col lg="9" md="7" sm="7" xs="12" className={"selected-sort-filter-mobile"}>
            <Row className="scroll-wrapper">
              <SelectedFilter
                searchKeyword={''}
                removeFilter={this.removeFilter}
                selectedCategory={this.props.match.params.category}
                data={filterParams}
                color={this.props.dataFilter.color}
                sex={this.props.dataFilter.sex}
                startPrice={this.props.dataFilter.startPrice}
                endPrice={this.props.dataFilter.endPrice}
                brands={this.props.dataFilter.brands}
                sizes={this.props.dataFilter.sizes}
                sneakers_condition={this.props.dataFilter.sneakers_condition}
                brandList={this.props.brandList}
                resetFilter={this.resetFilter}
                isCollectionPage={this.state.isCollectionPage}
                isHotProductsPage={this.state.isHotProductsPage && !this.state.isHotProductsAllCategoryPage}
                isMostPopularPage={this.state.isMostPopularPage}
                isBestSellingPage={this.state.isBestSellingPage}
              />
            </Row>
          </Col>
        </Row>

        <div className="product-list search__result">

          {
            (window.screen.availWidth < 480) ?
              null :
              (<div id='filter' className={isFilterOpen} >
                <div className={`sidebar ${isFilterOpen}`} >
                  <div className='content filter'>
                    {
                      this.renderFilterDropdown()
                    }
                  </div>
                </div>
              </div>)
          }

          <div id='product' ref={ref => (this.productContainerRef = ref)}>
            <div className='content'>
              {this.checkingSearchResult()}
            </div>
          </div>
        </div>
      </>
    )
  }

  handleSearchCounter(pagination) {
    const { errorMessageSearch } = this.props.dataProduct;
    if (pagination !== null) {
      if (errorMessageSearch === "Not Found") {
        return 0;
      } else {
        return pagination.total;
      }
    } else {
      return 0;
    }
  }

  renderKeywordSearch() {
    const params = this.getQueryParamsUrl();
    const keyword = params && params.keyword ? params.keyword : "";

    if (keyword === undefined) {
      return "Browse All";
    } else if (this.props.location.search == "?&sneakers_condition=new") {
      return "Kondisi Baru";
    } else if (this.props.location.search == "?&sneakers_condition=used") {
      return "Kondisi Bekas";
    } else if (this.props.location.search == "?&sneakers_condition=pre_order") {
      return "Kondisi PRE-ORDER";
    } else {
      return keyword.toUpperCase();
    }
  }

  /*
  render Counter hasil searching dan Filter
  */
  _renderSearchSummary() {
    const {
      searchKeyword,
      searchResult,
      redirectSearch,
      searchResultTmp,
      isFiltering,
      pagination,
      totalFilter
    } = this.props.dataProduct;
    const counterSearch =
      isFiltering === true ? searchResultTmp.length : searchResult.length;
    return (
      <Container className="page-container">
        <Row className="d-none">
          <div className="counter__search">
            <h3>Hasil Pencarian: </h3>
            <h3 className="search__keyword">'{this.renderKeywordSearch()}'</h3>
            {/* <h3 className="search__counter">({this.handleSearchCounter(pagination)})</h3> */}
          </div>
        </Row>
        {isFiltering === true ? (
          <Row className="d-none">
            <div className="counter__search">
              {/* <h3>Hasil Filter: </h3>
              <h3 className="search__counter">({ totalFilter  })</h3> */}
            </div>
          </Row>
        ) : null}
      </Container>
    );
  }

  handleClick(e) {
    e.preventDefault();
    this.setState({
      keyword_search: e.target.textContent
    });
  }

  setFocus() {
    this.searchInput.focus();
  }

  renderInitialPopular() {
    return (
      <div className="initial-popular">
        <Row style={{ marginTop: "1rem" }}>
          <Col
            lg="4"
            md="2"
            sm="4"
            xs="12"
            className="wrapper-popular-keywords"
          >
            {!this.props.dataPopular.hasOwnProperty("data") ? null : (
              <p className="popular-search popular">Popular keywords: </p>
            )}
          </Col>
          {/* <Col md="7"> */}
          {!this.props.dataPopular.hasOwnProperty("data")
            ? null
            : this.props.dataPopular.data.map((shoe, index) => (
              <Col
                lg="1"
                md="2"
                sm="8"
                xs="6"
                key={index}
                className="wrapper-popular-search"
              >
                <p
                  key={shoe.id}
                  className="popular-search"
                  onClick={this.handleClick}
                  style={{ fontSize: "12px", color: "#4a4a4a" }}
                >
                  {shoe.query}
                </p>
              </Col>
            ))}
          {/* </Col> */}
        </Row>
      </div>
    );
  }

  handleMappingSearchResult() {
    return this.renderInitialPopular();
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleButtonSearch = async () => {
    await this.setState({
      page: 1
    });
    const { searchCategory } = this.state;
    const { dataAuth, dataCategory } = this.props;
    const userId = dataAuth.isLogged ? dataAuth.userdata.id : null;
    const searchQuery = this.state.keyword_search.replace(/\+/g, " ").toUpperCase();
    const category = searchCategory;
    let dataSearch = {
      user_id: userId,
      query: searchQuery,
      category
    };

    let params =
      this.state.keyword_search === ""
        ? "Browse All"
        : this.state.keyword_search;
    let manipulate = this.state.keyword_search
      .trim()
      .split(" ")
      .join("+");
    this.props.history.push(
      `/search/${searchCategory}/${params
        .trim()
        .split(" ")
        .join("+")
        .toLowerCase()}`
    );
    const payload = {
      searchKeyword: manipulate.toUpperCase(),
      category: searchCategory
    };

    this.props.searchProduct(payload);
    if (
      this.state.keyword_search !== "" &&
      searchCategory !== "bcaxkickavenue"
    ) {
      this.props.saveSearchQueries(dataSearch);
      Analytics.recordSearch(
        userId,
        searchQuery,
        category
      )
    }
  };

  openSearch() {
    this.setState({
      openSearch: !this.state.openSearch
    });
  }

  handleClear() {
    this.setState({
      keyword_search: ""
    });
  }

  _handleScrolling() {
    const { scrollY, innerHeight } = window;
    if (scrollY >= innerHeight / 3 && !this.state.isVisible) {
      this.setState({
        isVisible: !this.state.isVisible
      });
    } else if (scrollY < innerHeight / 3 && this.state.isVisible) {
      this.setState({
        isVisible: !this.state.isVisible
      });
    }
  }

  _scrollToTop(bufferY = 0) {
    this.props.clientScroll.scrollYAnimated(bufferY);
  }

  toggleSidebar = () => {
    this.setState({ leftOpen: !this.state.leftOpen });
  }

  //filter and sort
  toggle = () => {
    this.props.setSortBy(!this.props.isSortOpen);
  }

  toggleFilter = () => {
    if (this.props.isFilterOpen == false) {
      const query = {
        params: { category: this.state.searchCategory }
      }
      // this.props.getAllBrands(query)
      // this.props.getAllSizes(query)
    }
    this.props.setFilter(!this.props.isFilterOpen);
  }

  toggleDrawer = () => {
    this.setState({
      isDrawerOpen: !this.state.isDrawerOpen
    })
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  _handleSorting(caseSort, sort_params) {
    const { searchCategory, isCollectionPage, isForYou, isPreVerified, isHotProductsPage, isBestSellingPage } = this.state;
    const { search, pathname } = this.props.history.location;
    let paramsRoute = search !== '' ? search.slice(1) : '';
    const params = this.getQueryParamsUrl();
    const keyword = params && params.keyword ? params.keyword : "";
    let searchKeywordFilter = keyword === undefined ? '' : keyword.toUpperCase().replace(/\+/g, ' ').trim();

    if (sort_params) {
      paramsRoute = paramsRoute.replace(`sort_by=${sort_params
        }`, '').replace('&&', '&')
    }

    //collection page
    const { caseSorting, collection } = this.props.dataProduct;
    const { slug, collectionType } = collection;
    const { selected } = this.props.dataCategory;

    let categoryFilter = searchCategory;
    if (searchCategory === 'streetwear' || searchCategory === 'fashion' || searchCategory === 'apparel') {
      categoryFilter = 'apparels';
    } else if (searchCategory === 'luxury') {
      categoryFilter = 'handbags';
    } else if (searchCategory === 'lifestyle' || searchCategory === 'toys' || searchCategory === 'electronics-collectibles') {
      categoryFilter = 'lifestyles';
    }

    const newParams = new URLSearchParams({
      ...params,
      sort_by: sort_params,
    });

    if (isPreVerified) newParams.set('pre_verified', true);

    const __params = {
      ...this.state.brandPageParams,
      sort_by: sort_params,
      category: categoryFilter,
      page: 1,
      per_page: 52,
      availables: true
    }

    this.props.doFetchBrandsProduct(this.objectToParamsString(__params))
  }

  renderSortDropdown() {
    const params = this.getQueryParamsUrl();
    const keyword = params && params.keyword ? params.keyword : "";
    let searchKeywordFilter = keyword === undefined ? 'BROWSE ALL' : keyword.toUpperCase().replace(/\+/g, ' ').trim();
    const { search } = this.props.history.location;
    const { currentSort, isCollectionPage, isHotProductsPage } = this.state;
    const { selected } = this.props.dataCategory;

    return (
      <div ref={this.sortWrapperRef} id={'filter-sort'} className="container__drop_down show__option sort__dropdown__wrapper">
        <div className="wrapping__btn btn-sort items__show">
          <Button
            style={{ fontFamily: currentSort === 'MOST_POPULAR' ? "DMSans-Bold" : "DMSans-Regular" }}
            onClick={() => {
              this.setState({
                currentSort: 'MOST_POPULAR'
              })
              this._handleSorting('MOST_POPULAR', 'most_popular')
              this.toggle()
            }}
          >Most Popular</Button>
        </div>
        <div className="wrapping__btn btn-sort items__show">
          <Button
            style={{ fontFamily: currentSort === 'NEWLY_ADDED' ? "DMSans-Bold" : "DMSans-Regular" }}
            onClick={() => {
              this.setState({
                currentSort: 'NEWLY_ADDED'
              })
              this._handleSorting('NEWLY_ADDED', 'product_desc')
              this.toggle()
            }}
          >Newly Added</Button>
        </div>
        <div className="wrapping__btn btn-sort items__show">
          <Button
            style={{ fontFamily: currentSort === 'MAX_MIN' ? "DMSans-Bold" : "DMSans-Regular" }}
            onClick={() => {
              this.setState({
                currentSort: 'MAX_MIN'
              })
              this._handleSorting('MAX_MIN', 'price_desc')
              this.toggle()
            }}
          >Highest to Lowest</Button>
        </div>
        <div className="wrapping__btn btn-sort items__show">
          <Button
            style={{ fontFamily: currentSort === 'MIN_MAX' ? "DMSans-Bold" : "DMSans-Regular" }}
            onClick={() => {
              this.setState({
                currentSort: 'MIN_MAX'
              })
              this._handleSorting('MIN_MAX', 'price_asc')
              this.toggle()
            }}
          >Lowest to Highest</Button>
        </div>
        <div className="wrapping__btn btn-sort items__show">
          <Button
            style={{ fontFamily: currentSort === 'SIZE_AVAILABILITY' ? "DMSans-Bold" : "DMSans-Regular" }}
            onClick={() => {
              this.setState({
                currentSort: 'SIZE_AVAILABILITY'
              })
              this._handleSorting('SIZE_AVAILABILITY', 'available_size')
              this.toggle()
            }}
          >Size Availability</Button>
        </div>
      </div>
    )
  }

  toggleModalSearch() {
    if (this.state.modal == false) {
      // this.props.getAllBrands()
      // this.props.getAllSizes()
    }
    this.setState({
      modal: !this.state.modal
    });

  }

  updateState = (key, val, unselectable = false) => {
    if (!unselectable)
      this.setState({ [key]: val })

    else {
      this.setState({
        [key]: this.state[key] === val ? '' : val //clear if the value is already selected
      })
    }
  }

  onSaveLastState = (sneakers_condition, startPrice, endPrice, sex, color) => {
    this.setState({
      sneakers_condition,
      startPrice,
      endPrice,
      sex,
      color
    })
  }

  renderFilterDropdown() {
    const { isCollectionPage, isHotProductsPage, isMostPopularPage, isBestSellingPage, sex, isHotProductsAllCategoryPage, isTrendingPage, isBestSellingAllCategoryPage, isPriceDropPage } = this.state;
    const { selected } = this.props.dataCategory;
    return (
      <div ref={this.filterWrapperRef}>
        <FilterDropdown
          history={this.props.history}
          match={this.props.match}
          onClose={this.toggleFilter}
          updateState={(key, val, unselectable = true) => this.updateState(key, val, unselectable = true)}
          isBrandExpanded={this.state.isBrandExpanded}
          isChildBrandExpanded={this.state.isChildBrandExpanded}
          isSizeExpanded={this.state.isSizeExpanded}
          isConditionExpanded={this.state.isConditionExpanded}
          isPriceExpanded={this.state.isPriceExpanded}
          activeSize={this.state.activeSize}
          activeApparelsSize={this.state.activeApparelsSize}
          selectedBrands={this.state.selectedBrands}
          selectedSizes={this.state.selectedSizes}
          sneakers_condition={this.state.sneakers_condition}
          startPrice={this.state.startPrice}
          endPrice={this.state.endPrice}
          onSaveLastState={this.onSaveLastState}
          dataCategory={this.props.dataCategory}
          isOpen={this.props.isFilterOpen}
          sex={this.state.sex}
          color={this.state.color}
          searchCategory={this.state.searchCategory}
          isCollectionPage={isCollectionPage}
          fetchHotProducts={this.fetchHotProducts}
          fetchMostPopular={this.fetchMostPopular}
          isMostPopularPage={isMostPopularPage}
          isBestSellingPage={isBestSellingPage}
          isForYou={this.state.isForYou}
          dataAuth={this.props.dataAuth}
          isPreVerified={this.state.isPreVerified}
          isMadeIndonesia={selected === "madeindonesia"}
          removeFilter={this.removeFilter}
          categoryOnly={isHotProductsAllCategoryPage || isTrendingPage || isBestSellingAllCategoryPage || isPriceDropPage}
          isHotProductsAllCategoryPage={isHotProductsAllCategoryPage}
          isTrendingPage={isTrendingPage}
          isBestSellingAllCategoryPage={isBestSellingAllCategoryPage}
          isPriceDropPage={isPriceDropPage}
          productAggregations={this.props.productAggregations}
          brandPageParams={this.state.brandPageParams}
          objectToParamsString={this.objectToParamsString.bind(this)}
        />
      </div>
    )
  }

  calculateSize = () => {
    let { maleSizes, femaleSizes, kidSizes } = this.state.selectedSizes
    let sizes = [...maleSizes, ...femaleSizes, ...kidSizes]
    const sizesTypes = sizes.map(s => s.sex).join(",");

    return sizes.length
      ? `sizes=${sizes.map(s => s.US).join(",")}&size_types=${sizesTypes}`
      : ''
  }

  getSizeIdHelper = () => {
    let { maleSizes, femaleSizes, kidSizes } = this.state.selectedSizes
    let sizes = [...maleSizes, ...femaleSizes, ...kidSizes]

    return sizes.length
      ? `sizeId=${sizes.map(s => s.id).join(",")}`
      : ''
  }

  removeFilter = (key) => {
    if (key === 'searchCategory') return;

    let { caseSorting, searchKeyword } = this.props.dataProduct;
    const queries = this.getQueryParamsUrl();
    const selectedCategory = this.props.match.params.category;

    this.setState({
      [key]: "",
    }, () => {
      let searchQueries = "";
      if (this.state.color) searchQueries += `colours=${this.state.color}&`
      if (this.state.sneakers_condition) searchQueries += `sneakers_condition=${this.state.sneakers_condition}&`
      if (this.state.startPrice) searchQueries += `startPrice=${this.state.startPrice}&`
      if (this.state.endPrice) searchQueries += `endPrice=${this.state.endPrice}&`
      if (this.state.sex) searchQueries += `sex=${this.state.sex}&`
      this.props.history.push({
        pathname: this.props.history.location.pathname,
        search: searchQueries
      });
    })
  }

  resetFilter = () => {
    if (this.state.isCollectionPage) {
      this.resetCollection()
    } else {
      this.resetSearch()
    }
  }

  resetSearch = () => {
    if (this.state.isTrendingPage || this.state.isHotProductsAllCategoryPage || this.state.isPriceDropPage || this.state.isBestSellingAllCategoryPage) {
      this.props.history.push(this.props.history.location.pathname);
      return;
    }

    const category = this.state.searchCategory || ""
    // const { caseSorting } = this.props.dataProduct;
    const pathname = this.props.location && this.props.location.pathname;
    const search = this.props.location && this.props.location.search;
    const caseSorting = 'MOST_POPULAR';

    this.setState({
      startPrice: "",
      endPrice: "",
      sneakers_condition: "",
      sex: "",
      color: "",
      brands: "",
      sizesParams: "",
      currentSort: caseSorting
    }, () => {
      this.props.doFilteringSearchToApi('', {
        params: {
          page: 1,
          availables: true,
          category: "",
          per_page: PER_PAGE_DEFAULT,
          sort_by: 'most_popular'
        }
      }, '')
      this.props.history.push({
        pathname: `/browse-all`,
        search: ''
      })
    })
  }

  /*
    render modal Filter
  */
  renderModalFilter() {
    return (
      <ModalFilterAndSort
        active={this.state.modal}
        toggleModalSearch={this.toggleModalSearch.bind(this)}
        history={this.props.history}
        match={this.props.match}
        typeFilter={this.state.typeFilter}
      />
    )
  }

  currentSort = (sort) => {
    switch (sort) {
      case "MOST_POPULAR":
        return "Most Popular"
      case "BEST_MATCH":
        return "Best Match"
      case "MAX_MIN":
        return "Highest to Lowest"
      case "MIN_MAX":
        return "Lowest to Highest"
      case "NEWLY_ADDED":
        return "Newly Added"
      case "SIZE_AVAILABILITY":
        return "Size Availability"

      default:
        return "Most Popular"
    }
  }

  convertSort = (sort) => {
    switch (sort) {
      case "most_popular":
        return "MOST_POPULAR"
      case "price_desc":
        return "MAX_MIN"
      case "price_asc":
        return "MIN_MAX"
      case "product_desc":
        return "NEWLY_ADDED"
      case "available_size":
        return "SIZE_AVAILABILITY"
      default:
        return 'BEST_MATCH';
    }
  }

  renderProducts = () => {
    const { products: { data, isFetching } } = this.props.dataCollection;
    const { computedMatch: { params: { category, slug } }, preVerifiedList } = this.props;
    const { isCollectionPage, collection_id, failedFetchCollectionData } = this.state;

    const findCollection = preVerifiedList.find((item) => item.slug === slug);
    const isCollectionPreVerified = findCollection?.['pre-verified'];

    if (this.state.isFetchingCollection && this.state.pageCollection === 1) {
      return <CardLoading />
    } else if (!this.state.isFetchingCollection && data.length === 0 || failedFetchCollectionData) {
      return <CardNotFound />
    }

    return (
      <div id="product">
        <Row>
          {
            data.map((item, index) => (
              <Sneaker
                hotProducts={item.editors_choice}
                {...item}
                category={this.props.dataCategory}
                key={index}
                outOfStock={item.out_of_stock}
                isPreVerified={isCollectionPreVerified}
                collectionSlug={slug}
                isCollectionPage={isCollectionPage}
                collection_id={collection_id}
              />
            ))
          }
        </Row>
      </div>
    )
  }

  _handleNextPageClickBrandProduct = async () => {
    try {
      const params = {
        ...this.state.brandPageParams,
        page: this.state.brandPageParams.page + 1
      }
      this.setState({
        brandPageParams: params
      })

      await this.props.doFetchBrandsProduct(this.objectToParamsString(params))
    } catch (error) {
      console.log(error)
    }
  }

  handleObserverHotProducts(entities, observer) {
    const { dataProduct: { pagination, stillPending } } = this.props;
    const { searchCategory, sort_by, isTrendingPage, isHotProductsAllCategoryPage, isBestSellingAllCategoryPage, isPriceDropPage } = this.state;
    const y = entities[0].boundingClientRect.y;

    const productsCategory = isTrendingPage || isHotProductsAllCategoryPage || isBestSellingAllCategoryPage || isPriceDropPage ? 'all_category' : searchCategory;

    this.setState({ prevYHotProducts: y });

    if (pagination !== null) {
      if (this.state.prevYHotProducts > y) {
        const curPage = this.state.pageHotProducts + 1;
        if (isTrendingPage) {
          this.props.getAdditionalPage('trends', {
            params: {
              page: this.state.pageHotProducts, availables: true, category: productsCategory, sort_by, range_type: 'week', range_value: 1
            }
          });
        } else if (isBestSellingAllCategoryPage) {
          this.props.getAdditionalPage('top-selling', {
            params: {
              page: this.state.pageHotProducts, availables: true, category: productsCategory, sort_by, range_type: 'week', range_value: 1
            }
          });
        } else if (isPriceDropPage) {
          this.props.getAdditionalPage('price-drop', {
            params: {
              page: this.state.pageHotProducts, availables: true, category: productsCategory, sort_by, range_type: 'month', range_value: 12
            }
          });
        } else {
          this.props.getAdditionalPage('editors-choices', {
            params: {
              page: this.state.pageHotProducts, availables: true, category: productsCategory, sort_by, range_type: 'month', range_value: 12
            }
          });
        }
        this.setState({ pageHotProducts: curPage, loadingHotProducts: true });
      }
    } else if (pagination === null && this.state.hasMoreHotProducts) {
      if (this.state.pageHotProducts === 1) {
        if (this.state.prevYHotProducts > y) {
          const curPage = this.state.pageHotProducts + 1;
          if (isTrendingPage) {
            this.props.getAdditionalPage('trends', {
              params: {
                page: this.state.pageHotProducts,
                availables: true,
                category: productsCategory,
                sort_by,
                range_type: 'week',
                range_value: 1,
              }
            });
          } else if (isBestSellingAllCategoryPage) {
            this.props.getAdditionalPage('top-selling', {
              params: {
                page: this.state.pageHotProducts,
                availables: true,
                category: productsCategory,
                sort_by,
                range_type: 'week',
                range_value: 1,
              }
            });
          } else if (isPriceDropPage) {
            this.props.getAdditionalPage('price-drop', {
              params: {
                page: this.state.pageHotProducts,
                availables: true,
                category: productsCategory,
                sort_by,
                range_type: 'month',
                range_value: 12,
              }
            });
          } else if (isHotProductsAllCategoryPage) {
            this.props.getAdditionalPage('editors-choices', {
              params: {
                page: this.state.pageHotProducts,
                availables: true,
                category: productsCategory,
                sort_by,
                range_type: 'month',
                range_value: 12,
              }
            });
          } else {
            this.props.getAdditionalPage('editors-choices', {
              params: {
                page: this.state.pageHotProducts,
                availables: true,
                category: productsCategory,
                sort_by,
              }
            });
          }
          this.setState({ pageHotProducts: curPage, loadingHotProducts: true });
        }
      } else {
        this.setState({
          loadingHotProducts: false
        })
      }
    }
  }

  renderBrandProduct = () => {
    const isUnreleased = this.props.statusPage === 'unreleased' ? false : true;

    const { data: searchResult, isFetch: stillPending } = this.props.dataProductBrandPage.products;
    const isExpressShipping = this.isExpressShippingProduct();

    if (stillPending && (searchResult && searchResult.length === 0)) {
      return <CardLoading />
    }

    if (searchResult && searchResult.length === 0 || !searchResult) {
      return (
        <CardNotFound title='This collection is still empty.' text='Stay tuned for more exciting selections in this section, do not miss out!' />
      )
    }

    return <InfiniteScroll
      dataLength={searchResult?.length ?? 0} //This is important field to render the next data
      next={this._handleNextPageClickBrandProduct}
      hasMore={this.state.hasMoreBrandProduct}
      loader={
        <SneakerLoadingSpinner
          isLoading
          isHide={false}
          wrapperRef={loadingRef => this.loadingRef = loadingRef}
        />
      }
      endMessage={
        <p style={{ textAlign: 'center' }}>
          <b>Yay! You have seen it all</b>
        </p>
      }
      scrollThreshold={0.95}
    >
      <Row
        className="result-search"
        style={{
          minHeight: 500,
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "row"
        }}
      >
        {searchResult?.length ? searchResult.map((item, index) => {
          const brand = item && item.product && item.product.brand;
          const brandSlug = brand?.flat?.[0] ? convertBrandNameToSlug(brand?.flat?.[0]) : brand?.slug;

          return (
            <Sneaker
              brandSlug={brandSlug}
              hotProducts={item.editors_choice}
              {...item}
              category={item?.category || 'all_category'}
              key={index}
              outOfStock={isUnreleased}
              statusPage={this.props.statusPage}
              isPreVerified={isExpressShipping} />
          );
        }) : null}
      </Row>
    </InfiniteScroll>
  }

  renderBrandPage = () => {
    const { searchCategory, dataSection } = this.props;
    const { isHotProductsAllCategoryPage, isTrendingPage, isBestSellingAllCategoryPage, isPriceDropPage } = this.state;

    let isFilterOpen = this.props.isFilterOpen ? 'open' : 'closed';
    const params = getQueryParamsUrl(this.props.history.location.search);
    const { imageLandscape, imagePortrait, products: { isFetching } } = this.props.dataCollection;
    const filterParams = [
      { key: "color", value: params.colours },
      { key: "sex", value: params.sex },
      { key: "startPrice", value: params.startPrice },
      { key: "endPrice", value: params.endPrice },
      { key: "sneakers_condition", value: params.sneakersCondition },
      { key: "sizeId", value: params.sizeId },
      { key: "sizeTypes", value: params.sizeTypes },
      { key: "sizes", value: params.sizes },
      { key: "sizeAlias", value: params?.sizeAlias },
    ].concat(params.brands ? params.brands.split(',').map(t => {
      return { key: "brands", value: t }
    }) : [{ key: "brands", value: undefined }]);

    const landscapeImage = dataSection.data && dataSection.data.images && dataSection.data.images.length > 0 ? dataSection.data.images.find((i) => i.orientation === "landscape") : null;
    const portraitImage = dataSection.data && dataSection.data.images && dataSection.data.images.length > 0 ? dataSection.data.images.find((i) => i.orientation === "portrait") : null;
    const mobileBanner = portraitImage ? portraitImage.URL : null;
    const desktopBanner = landscapeImage ? landscapeImage.URL : null;
    const bannerImageURL = searchCategory === "handbags" ? `${ASSET_IMAGE}/assets-image/hot-products-luxury-landscape.jpg` : `${ASSET_IMAGE}/assets-image/editors-pick-details.jpg`;

    if (isFetching && this.state.pageHotProducts === 1) {
      return <CardLoading />;
    }

    return (
      <>
        <div className="d-none d-sm-block">
          <Banner
            src={getCloudImageUrl(this.state.brandPageBanner?.URL ?? "", 2000, "editors-pick")}
            alt="banner"
          />
        </div>
        <div className="d-block d-sm-none">
          <Banner
            src={getCloudImageUrl(this.state.brandPageBanner?.URL ?? "", 1500, "editors-pick")}
            alt="banner"
          />
        </div>

        <TimerCountDown
          expiry={null}
          starts_at={null}
          name={this.state.brandName}
          description={this.state.brandDescription}
        />

        <Row className="filter__sort__product">
          <Col style={{ padding: 0 }} lg="1" md="2" sm="2" xs="6" className="border__btn__bottom btn__filter">
            {
              this.props.isFilterOpen &&
              <div onClick={this.toggleFilter} className="wrapping__btn btn-filter">
                <span><KickImage className="filter__icon" src={IconFilter} alt="" /> Filter <i className="fa fa-angle-left"></i></span>
              </div>
            }
            {
              !this.props.isFilterOpen &&
              <div onClick={this.toggleFilter} className="wrapping__btn btn-filter">
                <span><KickImage className="filter__icon" src={IconFilter} alt="" /> Filter <i className="fa fa-angle-right"></i></span>
              </div>
            }
          </Col>

          <Col style={{ padding: 0 }} lg="9" md="7" sm="7" xs="" className={"selected-sort-filter"}>
            <Row className="scroll-wrapper">
              <SelectedFilter
                searchKeyword={''}
                removeFilter={this.removeFilter}
                selectedCategory={(this.state.isTrendingPage || this.state.isBestSellingAllCategoryPage || this.state.isHotProductsAllCategoryPage || this.state.isPriceDropPage) ? getQueryParamsUrl(this.props.history.location.search).category : this.props.match.params.category}
                data={filterParams}
                color={this.props.dataFilter.color}
                sex={this.props.dataFilter.sex}
                startPrice={this.props.dataFilter.startPrice}
                endPrice={this.props.dataFilter.endPrice}
                brands={this.props.dataFilter.brands}
                sizes={this.props.dataFilter.sizes}
                sneakers_condition={this.props.dataFilter.sneakers_condition}
                brandList={this.props.brandList}
                resetFilter={this.resetFilter}
                isCollectionPage={this.state.isCollectionPage}
                isHotProductsPage={this.state.isHotProductsPage && !this.state.isHotProductsAllCategoryPage}
                isMostPopularPage={this.state.isMostPopularPage}
                isBestSellingPage={this.state.isBestSellingPage}
              />
            </Row>
          </Col>

          <Col style={{ padding: 0 }} lg="2" md="3" sm="3" xs="6" className={`border__btn__bottom btn__sort`}>
            <div className="wrapping__btn btn-sort border__btn__bottom" onClick={this.toggle}>
              <p>Sort: <span>{this.currentSort(this.state.currentSort)} </span></p><i className={this.props.isSortOpen ? "fa fa-angle-up" : "fa fa-angle-down"}></i>
            </div>
            {
              this.props.isSortOpen &&
              this.renderSortDropdown()
            }
          </Col>
        </Row>

        <Row className="filter__sort__drawer">
          <Col style={{ padding: 0 }} lg="1" md="2" sm="2" xs="5" className="border__btn__bottom btn__filter">
            {
              this.state.isDrawerOpen &&
              <div onClick={this.toggleDrawer} className="wrapping__btn btn-filter">
                <span><KickImage className="filter__icon" src={IconFilter} alt="" /> Filter <i className="fa fa-angle-left"></i></span>
              </div>
            }
            {
              !this.state.isDrawerOpen &&
              <div onClick={this.toggleDrawer} className="wrapping__btn btn-filter">
                <span><KickImage className="filter__icon" src={IconFilter} alt="" /> Filter <i className="fa fa-angle-right"></i></span>
              </div>
            }
          </Col>

          <Col style={{ padding: 0 }} lg="2" md="3" sm="3" xs="7" className={`border__btn__bottom btn__sort`}>
            {
              this.props.isSortOpen &&
              <div className="wrapping__btn btn-sort border__btn__bottom" onClick={this.toggle}>
                <p>Sort: <span>{this.currentSort(this.state.currentSort)} </span></p><i className="fa fa-angle-up"></i>
              </div>
            }
            {
              !this.props.isSortOpen &&
              <div className="wrapping__btn btn-sort border__btn__bottom" onClick={this.toggle}>
                <p>Sort: <span>{this.currentSort(this.state.currentSort)} </span></p><i className="fa fa-angle-down"></i>
              </div>
            }
            {
              this.props.isSortOpen &&
              this.renderSortDropdown()
            }
          </Col>
        </Row>

        <Row className="filter__sort__drawer">
          <Col lg="9" md="7" sm="7" xs="12" className={"selected-sort-filter-mobile"}>
            <Row className="scroll-wrapper">
              <SelectedFilter
                searchKeyword={''}
                removeFilter={this.removeFilter}
                selectedCategory={(this.state.isTrendingPage || this.state.isBestSellingAllCategoryPage || this.state.isHotProductsAllCategoryPage || this.state.isPriceDropPage) ? getQueryParamsUrl(this.props.history.location.search).category : this.props.match.params.category}
                data={filterParams}
                color={this.props.dataFilter.color}
                sex={this.props.dataFilter.sex}
                startPrice={this.props.dataFilter.startPrice}
                endPrice={this.props.dataFilter.endPrice}
                brands={this.props.dataFilter.brands}
                sizes={this.props.dataFilter.sizes}
                sneakers_condition={this.props.dataFilter.sneakers_condition}
                brandList={this.props.brandList}
                resetFilter={this.resetFilter}
                isCollectionPage={this.state.isCollectionPage}
                isHotProductsPage={this.state.isHotProductsPage && !this.state.isHotProductsAllCategoryPage}
                isMostPopularPage={this.state.isMostPopularPage}
                isBestSellingPage={this.state.isBestSellingPage}
              />
            </Row>
          </Col>
        </Row>

        <div className="product-list search__result">

          {
            (window.screen.availWidth < 480) ?
              null :
              (<div id='filter' className={isFilterOpen} >
                <div className={`sidebar ${isFilterOpen}`} >
                  <div className='content filter'>
                    {
                      this.renderFilterDropdown()
                    }
                  </div>
                </div>
              </div>)
          }

          <div id='product' ref={ref => (this.productContainerRef = ref)}>
            <div className='content'>

              <div className="product-list">
                {this.renderBrandProduct()}
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  isExpressShippingProduct = () => {
    return isExpressShippingFiltered(this.state.sneakers_condition);
  }

  render() {
    const { dataProduct, searchKeyword, dataSection, countdown_modal } = this.props;
    const { metaDescription, metaTitle } = this.state;
    const notFound = dataProduct.searchResult.length === 0 || dataProduct.errorMessageSearch === "Sneaker tidak tersedia!" ||
      dataProduct.errorMessageSearch === "Not Found"

    let leftOpen = this.state.leftOpen ? 'open' : 'closed';
    let rightOpen = this.state.rightOpen ? 'open' : 'closed';

    let isFilterOpen = this.props.isFilterOpen ? 'open' : 'closed';

    //filter and sort
    const params = getQueryParamsUrl(this.props.history.location.search);
    const arrayOfObj = Object.keys(params).map((key) => [(key), params[key]]);

    let { brands } = this.props.dataFilter;
    const selectedBrand = brands.find(brand => brand.id === 1);

    //collection page
    const { isCollectionPage, isHotProductsPage, isMostPopularPage, isBestSellingPage, searchCategory, isForYou } = this.state;
    const filterParams = [
      { key: "color", value: params.colours },
      { key: "sex", value: params.sex },
      { key: "startPrice", value: params.startPrice },
      { key: "endPrice", value: params.endPrice },
      { key: "sneakers_condition", value: params.sneakersCondition },
      { key: "sizeId", value: params.sizeId },
      { key: "sizeTypes", value: params.sizeTypes },
      { key: "sizes", value: params.sizes }
    ].concat(params.brands ? params.brands.split(',').map(t => {
      return { key: "brands", value: t }
    }) : [{ key: "brands", value: undefined }]);

    const { imageLandscape, imagePortrait } = this.props.dataCollection;

    const { isFetching: isLoading, slug, collectionType, products: { data, isFetching } } = this.props.dataProduct;

    return (
      <>
        <Helmet>
          <title>{metaTitle}</title>
          {metaDescription !== '' && <meta
            name="description"
            content={metaDescription}
            data-react-helmet="true"
          />}
        </Helmet>
        {this.renderFilterDrawer()}
        <Container fluid id="search__result__container" className={countdown_modal ? 'countdown-active' : ''}>
          {this.state.isDrawerOpen ? <div /> : this.renderBrandPage()}
        </Container>
      </>
    );
  }
}

const mapStateToProps = state => ({
  dataAuth: state.dataAuth,
  dataProduct: state.dataProduct,
  activeId: state.dataProduct.activeId,
  dataPopular: state.dataProduct.productPopulars,
  dataCategory: state.dataCategory,
  dataKaFair: state.dataKaFair,
  countdown_modal: state.dataMenu.countdown_modal,

  //filter and sort
  isSortOpen: state.dataUi.isSortOpen,
  isFilterOpen: state.dataUi.isFilterOpen,
  dataFilter: state.filterReducer,
  brandList: state.filterReducer.brands,

  //collection page
  dataCollection: state.dataProduct.collection,
  searchKeyword: state.dataProduct.searchKeyword,

  //hot products
  dataSection: state.dataProduct.dataSection,

  //most popular
  dataTopSelling: state.dataProduct.topSelling,
  dataTrendingNow: state.dataProduct.searchResult,

  //for you
  dataRecommended: state.dataProduct.dataRecommended,

  //get pre verified collection list
  preVerifiedList: state.dataKaFair.pre_verified_list.data,

  //product aggregations
  productAggregations: state.dataProduct.productAggregations,

  dataProductBrandPage: state.dataProductBrandPage,
});

const mapDispatchToProps = dispatch => {
  return {
    searchProduct: params => dispatch(searchProduct(params)),
    doBrowseAll: (page, status_action) =>
      dispatch(doBrowseAll(page, status_action)),
    getList: query => dispatch(doFetchProducts(query)),
    doFilteringSearchToApi: (params, page, action) =>
      dispatch(doFilteringSearchToApi(params, page, action)),
    searchToLoadMore: params => dispatch(searchToLoadMore(params)),
    updateActiveId: (id) => dispatch(updateActiveId(id)),
    sortingSearchResultAPI: (paramsRoute, caseSort, status_action) =>
      dispatch(sortingSearchResultAPI(paramsRoute, caseSort, status_action)),
    saveSearchQueries: dataSearch => dispatch(saveSearchQueries(dataSearch)),
    getPopularSearch: params => dispatch(doFetchPopularSearch(params)),
    hideLoading: () => dispatch(hideLoading()),

    //filter and sort
    getAllBrands: (query) => dispatch(getAllBrands(query)),
    getAllSizes: (query) => dispatch(getAllSizes(query)),
    getPopularSearch: (query) => dispatch(doFetchPopularSearch(query)),
    setSortBy: payload => dispatch(doSetSortBySearch(payload)),
    setFilter: payload => dispatch(doSetFilterSearch(payload)),

    //collection page
    getCollectionBySlug: (category, slug) => dispatch(getCollectionBySlug(category, slug)),
    getCollectionProduct: (id, payload) => dispatch(getCollectionProduct(id, payload)),
    searchState: (keyword) => dispatch(searchState(keyword)),
    fetchCollectionProduct: (payload, filterQueries) => dispatch(fetchCollectionProduct(payload, filterQueries)),

    // for refreshing currency rate
    fetchProfile: () => dispatch(doFetchProfile()),
    fetchCurrencyRate: (payload) => dispatch(doFetchCurrencyRate(payload)),

    //hot products
    getAdditionalPage: (type, params) => dispatch(getAdditionalPage(type, params)),
    getDetailSection: (category, type) => dispatch(getDetailSection(category, type)),

    //most popular
    getTopSellingProduct: (params) => dispatch(getTopSellingProduct(params)),

    //for you
    getRecommendedProduct: (userId, category, filterQueries) => dispatch(getRecommendedProduct(userId, category, filterQueries)),

    // KAFAIR
    getPreVerifiedCollectionList: () => dispatch(getPreVerifiedCollectionList()),
    recordCollectionActivity: (params) => dispatch(recordCollectionActivity(params)),
    saveCollectionSort: (sort_by) => dispatch(saveCollectionSort(sort_by)),
    resetCollectionData: () => dispatch(resetCollectionStateData()),
    doFetchBrandsProduct: (stringParams) => dispatch(doFetchBrandsProduct(stringParams)),
  };
};

const connectRedux = connect(mapStateToProps, mapDispatchToProps);

export default connectRedux(withScrollTo(withRouter(BrandPage)));
